import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white text-center py-4">
      <p>&copy; {new Date().getFullYear()} AgriSync AI — Empowering Farmers 🌿</p>
    </footer>
  );
};

export default Footer;
